import type { ConcentrationTimePoint } from '@bioavail/shared-types';

/**
 * Index of the maximum concentration (Cmax) in a concentration-time series.
 * Returns the earliest index on ties, matching the linear-up/log-down split
 * convention used throughout the AUC engine (PSD §4.2.3, §4.2.10).
 *
 * Assumes `points` is already sorted by ascending time and is non-empty.
 */
export function findCmaxIndex(points: ConcentrationTimePoint[]): number {
  let cmaxIndex = 0;
  let cmax = points[0]!.concentration;
  for (let i = 1; i < points.length; i++) {
    if (points[i]!.concentration > cmax) {
      cmax = points[i]!.concentration;
      cmaxIndex = i;
    }
  }
  return cmaxIndex;
}
